import lodash from 'lodash';
import React from 'react';

export const TEXT_PROPERTIES: Array<keyof React.CSSProperties> = [
  'color',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'letterSpacing',
  'opacity',
  'textDecoration',
  'textTransform',
  'textAlign',
];

export const CONTAINER_PROPERTIES: Array<keyof React.CSSProperties> = [
  'backgroundColor',
  'border',
  'borderRadius',
  'boxShadow',
  'margin',
  'opacity',
  'padding',
  'paddingLeft',
  'borderTop',
  'borderLeft',
  'borderRight',
  'borderBottom',
  'width',
  'height',
  'borderColor',
  'scale',
  'translate',
  'justifyContent',
];

export const SELECT_PROPERTIES: Array<keyof React.CSSProperties> = [
  'color',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'letterSpacing',
  'opacity',
  'borderRadius',
  'backgroundColor',
  'border',
  'margin',
  'opacity',
  'padding',
];

export const p = (
  theme: Themes,
  key: string,
  properties: ThemeProperties,
  { enableThemeKeyHints }: { enableThemeKeyHints: boolean },
) => {
  const result: React.CSSProperties = enableThemeKeyHints
    ? {
        // We smuggle the themeKey into the devtools using this CSS property.
        // All our other attempts to communicate custom info via inline styles get filtered out.
        // This break animations, so it is only available via a button in the localhost/DEV version.
        animationName: `themeKey_${key}`,
      }
    : {};

  if (!theme || !properties || !key) {
    return result;
  }

  if (Array.isArray(properties)) {
    properties.forEach(property => {
      const value = lodash.get(theme, `${property}.${key}`);
      if (value != null) {
        //@ts-ignore
        result[property] = value;
      }
    });
  }

  //TODO: add mobile theme key support

  return result;
};

export default p;
